/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LeaderboardEntry } from '../models/LeaderboardEntry';
import type { PaginationResponse } from '../models/PaginationResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PromotionalEventsService {
    /**
     * Get event leaderboard
     * Get top 100 leaderboard for a specific promotional event
     * @param eventId Promotional event ID
     * @returns any Leaderboard retrieved successfully
     * @throws ApiError
     */
    public static getV1PromotionalEventsLeaderboard(
        eventId: string,
    ): CancelablePromise<{
        eventId?: string;
        eventName?: string;
        leaderboard?: Array<LeaderboardEntry>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/promotional-events/{eventId}/leaderboard',
            path: {
                'eventId': eventId,
            },
            errors: {
                404: `Event not found`,
            },
        });
    }
    /**
     * Get user's promotional events history
     * Get authenticated user's participation history in past promotional events
     * @param limit Number of events to return (max 50)
     * @param offset Number of events to skip
     * @returns any History retrieved successfully
     * @throws ApiError
     */
    public static getV1PromotionalEventsHistory(
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<{
        events?: Array<{
            event?: {
                id?: string;
                name?: string;
                description?: string;
                startedAt?: string;
                endsAt?: string;
                primaryColor?: string;
                secondaryColor?: string;
            };
            stats?: {
                totalEarned?: number;
                spent?: number;
                available?: number;
            };
        }>;
        pagination?: PaginationResponse;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/promotional-events/history',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Authentication required`,
            },
        });
    }
}
